"use strict";

var Logger = require("js-logger");

Logger.useDefaults({
	defaultLevel: Logger.ERROR
});

module.exports = {
	EventSearchPaging: require("./EventSearchPaging"),
	SearchActions: require("../actions/SearchActions"),
	SearchPaging: require("./SearchPaging"),
	SearchSorting: require("./SearchSorting"),
	Spinner: require("../client/Spinner"),
	SponsorshipSearchHelper: require("../sponsorshipComponents/SponsorshipSearchHelper"),
	SponsorshipSearchPaging: require("./SponsorshipSearchPaging")
};
